import {BoxProps} from '@polysky-libs/uikit'
import React from 'react'

const Container: React.FC<BoxProps> = ({children}) => <>{children}</>

export default Container
